import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum EResetDiscussionsActionType {
  Reset = 'discussions/resetDiscussions',
}

export type TResetDiscussions = ITypedReduxAction<EResetDiscussionsActionType.Reset>;
